import React, { Component } from 'react';
import Typography from 'material-ui/Typography';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import QueryService from './QueryService';

class BoatsPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            boats: [],
            error: false,
        };
        this.new_file_note = React.createRef();
        this.new_file_file = React.createRef();
    }

    getServerState() {
        QueryService.get('/boats')
            .then(json => {
                this.setState({boats: Object.values(json)});
            })
            .catch(err => {
                console.log('cannot fetch boats, could be redirection error due to not being logged in', err);
                this.setState({error: true});
            });
    }

    componentDidMount() {
        this.getServerState();
    }

    deleteBoat(boat_id) {
        if (window.confirm("are you sure?")) {
            QueryService.deleteResource(`/boats/${boat_id}`).then(() => {this.getServerState()});
        }
        return false;
    }

    render() {
        const {boats, error} = this.state;
        if (! error) {
            const columns = [
                {
                    Header: 'U number',
                    accessor: 'u_number',
                    Cell: props => <Typography>{props.value}</Typography>
                },
                {
                    Header: 'Name',
                    accessor: 'name',
                    Cell: props => <Typography>{props.value}</Typography>
                },
                {
                    Header: 'Image',
                    accessor: 'image',
                    Cell: props => <div><Typography>{props.value}</Typography><img src={props.value} width="200" alt=""></img></div>
                },
                {
                    Header: 'Image Thumb',
                    accessor: 'image_thumb',
                    Cell: props => <div><Typography>{props.value}</Typography><img src={props.value} alt=""></img></div>
                },
                {
                    Header: 'Action',
                    accessor: 'id',
                    Cell: props => <button onClick={() => this.deleteBoat(props.value)}>Delete</button>
                }
            ];

            return (
                <div>
                    <Typography variant="title">Boats</Typography>
                    <ReactTable data={boats} columns={columns} className='-striped' defaultPageSize={50} />
                </div>
            );
        } else {
            return <div>Error!</div>;
        }
    }
}

export default BoatsPage;



// WEBPACK FOOTER //
// ./src/Boats.js